import { DepartureInventory, ReservationInventory } from '~/types/tours/inventory';

import { request } from './common';
import { OkResponse, toursBasePath } from './toursApi';

/**
 * The inventory held against one departure of a supplier service: what has been
 * sold, on which package option, and the ledger entry behind each unit.
 */
export async function getDepartureInventory(
  { serviceId, departureId }: { serviceId: string; departureId: string },
  options?: { signal?: AbortSignal },
): Promise<DepartureInventory> {
  const response: OkResponse<DepartureInventory> = await request(
    `${toursBasePath()}/services/${serviceId}/departures/${departureId}/inventory`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}

/** What one reservation's travellers hold, grouped by traveller. */
export async function getReservationInventory(
  reservationId: string,
  options?: { signal?: AbortSignal },
): Promise<ReservationInventory> {
  const response: OkResponse<ReservationInventory> = await request(
    `${toursBasePath()}/reservations/${reservationId}/inventory`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}
